import React from "react";

import "./style.css";

function PropertyMarker({ params, className, property }) {
  const isPropertyAvailable = property.finalPrice > 0;

  return (
    <div
      style={{
        position: "relative",
      }}
      className={className}
      hover-img-id={property.id}
    >
      <div role="link" tabindex="-1" aria-label="property marker">
        <div className="marker-google-map marker-google-map-t">
          <div
            className="svg-main-marker"
            style={{
              "--var-main-marker-color":
                params.propertyDetails.propertyId == property.id
                  ? "var(--clr-secondary)"
                  : "var(--clr-primary)",
            }}
          >
            {property?.isLiked ? (
              <svg className="main-marker-heart-svg" viewBox="-1 -1 26 32">
                <path d="M24 12.4286C24 19.2927 12 29 12 29C12 29 0 19.2927 0 12.4286C0 5.56446 5.37258 0 12 0C18.6274 0 24 5.56446 24 12.4286Z"></path>
              </svg>
            ) : (
              <svg className="main-marker-svg" viewBox="-1 -1 26 32">
                <path d="M24 12.4286C24 19.2927 12 29 12 29C12 29 0 19.2927 0 12.4286C0 5.56446 5.37258 0 12 0C18.6274 0 24 5.56446 24 12.4286Z"></path>
              </svg>
            )}

            {property?.isLiked ? (
              <span className="marker-svg-heart marker-icon">
                <svg viewBox="0 0 25 25" className="marker-icon-heart">
                  <path d="M23.3 5.076a6.582 6.582 0 0 0-10.446-1.71L12 4.147l-.827-.753a6.522 6.522 0 0 0-5.688-1.806A6.472 6.472 0 0 0 .7 5.075a6.4 6.4 0 0 0 1.21 7.469l9.373 9.656a1 1 0 0 0 1.434 0l9.36-9.638A6.414 6.414 0 0 0 23.3 5.076z"></path>
                </svg>
              </span>
            ) : (
              <span className="marker-svg marker-icon" aria-hidden="true">
                <svg
                  viewBox="0 0 10 10"
                  className="marker-icon-dot"
                  style={{ fill: isPropertyAvailable ? "#ffffff" : "#FFA407" }}
                >
                  <circle r="4" cx="5" cy="5"></circle>
                </svg>
              </span>
            )}
          </div>

          <div className="marker-shadow">
            <svg viewBox="0 0 12 4">
              <ellipse cx="6" cy="2" rx="6" ry="2"></ellipse>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyMarker;
